module.exports = __webpack_public_path__ + "img/Landing-MVP-Header-2.ed50c4e4.jpg";